import { Chip } from '@heroui/react'
import { languageNames } from '../lib/i18n/missing'
import { useStaffText } from './StaffText'

type Say = ReturnType<typeof useStaffText>['say']

/** "Missing: Russian", or with how many texts miss it, "Missing: Russian (3)". */
export function missingLabel(say: Say, codes: readonly string[], n?: number): string {
  const langs = languageNames(codes)
  return n !== undefined && n > 1 ? say('content.missingCount', { langs, n }) : say('content.missing', { langs })
}

/** A warning chip naming the customer languages some words lack; nothing when none. */
export function MissingMark({ codes, n }: { codes: readonly string[]; n?: number }) {
  const { say } = useStaffText()
  if (codes.length === 0) return null
  return (
    <Chip size="sm" variant="soft" color="warning" className="missing-mark">
      {missingLabel(say, codes, n)}
    </Chip>
  )
}
